const DEFAULT_IMAGE = require("@/assets/images/product-sample-image.png");

export { DEFAULT_IMAGE };
